import React, { useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { showInfoNotification } from "components/framework/notification/NotificationUtil";
import { handleFieldErrors } from "services/util/ApiUtil";
import { useIsMounted } from "services/customHooks/useIsMounted";
import { NetworkProfileApi } from "services/apis/NetworkProfileApi";
import { NetworkExplorerContext } from "../NetworkExplorer";
import ConfirmationModal from "components/framework/modals/ConfirmationModal";

type Props = {
  id: string;
  lrn: string;
  lata: string;
  closeModal: () => void;
};

export default function NetworkProfileDeleteModal(props: Props) {
  const intl = useIntl();
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const networkExplorerContext = useContext(NetworkExplorerContext);
  const isMounted = useIsMounted();

  const handleDelete = () => {
    if (isMounted.current) {
      setShowLoadingIndicator(true);
    }

    NetworkProfileApi.dualCarrierDelete(props.id, props.lata, props.lrn)
      .then(() => {
        showInfoNotification(intl.formatMessage({ id: "network.networkProfile.delete.deleteNotification" }));
        if (isMounted.current) {
          networkExplorerContext.networkProfileActionCallback();
          props.closeModal();
        }
      })
      .catch(error => handleFieldErrors(error))
      .finally(() => {
        if (isMounted.current) {
          setShowLoadingIndicator(false);
        }
      });
  };

  return (
    <ConfirmationModal
      confirmCallback={handleDelete}
      closeModal={props.closeModal}
      title={intl.formatMessage({ id: "network.networkProfile.delete.deleteModalTitle" })}
      confirmButtonText={intl.formatMessage({ id: "network.networkProfile.delete.submitDelete" })}
      showLoadingIndicator={showLoadingIndicator}>
      <p>
        <FormattedMessage id="network.networkProfile.delete.deleteQuestion" values={{ lrn: props.lrn }} />
      </p>
    </ConfirmationModal>
  );
}
